// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__cCi8h","footer":"Form_footer__2a-Jv"};